import { Component, Input, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserOperation } from '../../../../core/enums/user-operation';
import { ShiveDialogService } from '../../../../core/services/controls/shive-dialog.service';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { WorkingTimeModel } from '../../../../core/models/user/working-time.model';
import { WorkingTimeService } from '../../../../core/services/features/working-time/working-time.service';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'app-working-time-dialog',
  templateUrl: './working-time-dialog.component.html',
  standalone: false,
})
export class WorkingTimeDialogComponent implements OnInit {
  @Input() workingTimeHistory: WorkingTimeModel[];
  public workingTimeHistoryForm: FormGroup;
  public updateEnabled = false;
  protected readonly faPenToSquare = faPenToSquare;
  private readonly formBuilder = inject(FormBuilder);
  private readonly shiveDialogService = inject(ShiveDialogService);
  private readonly authService = inject(AuthService);
  private readonly workingTimeService = inject(WorkingTimeService);
  private currentIndex = -1;

  ngOnInit(): void {
    this.initForm();
  }

  public close(): void {
    this.shiveDialogService.close(UserOperation.Cancel);
  }

  public submit(): void {
    this.shiveDialogService.close(this.workingTimeHistory);
  }

  public inputValueChanged(newValue: unknown, source: string): void {
    this.updateEnabled = newValue !== null;
    (this.workingTimeHistory[this.currentIndex] as any)[source] = newValue;
  }

  public entryIndexChanged(index: number) {
    if (this.workingTimeHistory.length < index) {
      return;
    }
    this.currentIndex = index;
    const workingTimeEntry = this.workingTimeHistory[index];
    this.workingTimeHistoryForm.controls.monday.patchValue(workingTimeEntry.monday);
    this.workingTimeHistoryForm.controls.tuesday.patchValue(workingTimeEntry.tuesday);
    this.workingTimeHistoryForm.controls.wednesday.patchValue(workingTimeEntry.wednesday);
    this.workingTimeHistoryForm.controls.thursday.patchValue(workingTimeEntry.thursday);
    this.workingTimeHistoryForm.controls.friday.patchValue(workingTimeEntry.friday);
    this.workingTimeHistoryForm.controls.saturday.patchValue(workingTimeEntry.saturday);
    this.workingTimeHistoryForm.controls.sunday.patchValue(workingTimeEntry.sunday);
  }

  private initForm(): void {
    const user = this.authService.getLoggedInUserClone();
    this.currentIndex = user.workingTimeEntries.length - 1;
    const workingTimeEntry = this.workingTimeService.getCurrentWorkingTimeEntry(user);
    this.workingTimeHistoryForm = this.formBuilder.group({
      monday: workingTimeEntry.monday,
      tuesday: workingTimeEntry.tuesday,
      wednesday: workingTimeEntry.wednesday,
      thursday: workingTimeEntry.thursday,
      friday: workingTimeEntry.friday,
      saturday: workingTimeEntry.saturday,
      sunday: workingTimeEntry.sunday,
      entryIndex: this.currentIndex,
    });
  }
}
